import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import Marketing from "@/pages/Marketing";
import { Login, Register } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import { LoadsList, NewLoad, LoadDetail, AddVehicle } from "@/pages/Loads";
import { VehicleDetail, InspectionFlow } from "@/pages/Vehicle";
import { LocationsList, NewLocation, History } from "@/pages/Locations";
import Training from "@/pages/Training";
import Billing, { PaymentSuccess, PaymentCancel } from "@/pages/Billing";
import Fleet, { JoinFleet } from "@/pages/Fleet";
import Activity from "@/pages/Activity";
import Reports from "@/pages/Reports";
import Referrals, { ReferralLanding } from "@/pages/Referrals";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-display">Loading…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <Routes>
      <Route path="/" element={<Marketing/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="/register" element={<Register/>}/>
      <Route path="/app" element={<Protected><Dashboard/></Protected>}/>
      <Route path="/app/loads" element={<Protected><LoadsList/></Protected>}/>
      <Route path="/app/loads/new" element={<Protected><NewLoad/></Protected>}/>
      <Route path="/app/loads/:id" element={<Protected><LoadDetail/></Protected>}/>
      <Route path="/app/loads/:id/add-vehicle" element={<Protected><AddVehicle/></Protected>}/>
      <Route path="/app/vehicles/:id" element={<Protected><VehicleDetail/></Protected>}/>
      <Route path="/app/vehicles/:id/inspection/:type" element={<Protected><InspectionFlow/></Protected>}/>
      <Route path="/app/locations" element={<Protected><LocationsList/></Protected>}/>
      <Route path="/app/locations/new" element={<Protected><NewLocation/></Protected>}/>
      <Route path="/app/history" element={<Protected><History/></Protected>}/>
      <Route path="/app/training" element={<Protected><Training/></Protected>}/>
      <Route path="/app/billing" element={<Protected><Billing/></Protected>}/>
      <Route path="/app/fleet" element={<Protected><Fleet/></Protected>}/>
      <Route path="/app/activity" element={<Protected><Activity/></Protected>}/>
      <Route path="/app/reports" element={<Protected><Reports/></Protected>}/>
      <Route path="/app/referrals" element={<Protected><Referrals/></Protected>}/>
      <Route path="/r/:code" element={<ReferralLanding/>}/>
      <Route path="/join/:token" element={<JoinFleet/>}/>
      <Route path="/payment/success" element={<PaymentSuccess/>}/>
      <Route path="/payment/cancel" element={<PaymentCancel/>}/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router/>
        <Toaster position="bottom-right" richColors mobileOffset={{ bottom: "calc(5rem + env(safe-area-inset-bottom))" }}/>
      </AuthProvider>
    </div>
  );
}
